/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { GlobalContext } from '../contexts';

import type { AppStorage } from '../../../../helpers/storages';

export const useGlobalAppStorage = (): AppStorage | null => useContext(GlobalContext).appStorage;
